<template>
    <div class="row g-2">
        <!-- Available drivers -->
        <div class="col-5 available ms-3">
            <div class="col-12">
                <label for="warehousemen" class="">{{ $t("warehouses.warehousemenAvailable") }}</label>
            </div>
            <ul>
                <li v-for="warehouseman in warehousemen" :key="warehouseman.id" :value="warehouseman" @click="moveToSelected(warehouseman)">
                    {{ warehouseman.username }}
                </li>
            </ul>
        </div>
        <!-- Selected warehousemens -->
        <div class="col-5 selected mx-auto ms-3">
            <div class="col-12">
                <label for="warehousemens" class="">{{ $t("warehouses.warehousemenSelected") }}</label>
            </div>
            <ul>
                <li v-for="warehouseman in selectedWarehousemen" :key="warehouseman.id" :value="warehouseman"
                    @click="moveToAllWarehousemen(warehouseman)">
                    {{ warehouseman.username }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        warehousemen: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedWarehousemen: [],
        };
    },
    methods: {
        emitWrehousemanSelected() {
            this.$emit('warehousemen-selected', this.selectedWarehousemen);
        },
        moveToSelected(warehousemen) {
            const index = this.warehousemen.indexOf(warehousemen);
            if (index !== -1) {
                this.selectedWarehousemen.push(this.warehousemen.splice(index, 1)[0]);
                this.emitWrehousemanSelected();
            }
        },
        moveToAllWarehousemen(warehousemen) {
            const index = this.selectedWarehousemen.indexOf(warehousemen);
            if (index !== -1) {
                this.warehousemen.push(this.selectedWarehousemen.splice(index, 1)[0]);
                this.emitWrehousemanSelected();
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/scss/abstracts/_variables.scss";

ul {
    list-style-type: none;
    padding: 0;
    border: 1px solid $black;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;
}

label {
    font-weight: bold;
    margin-bottom: 5px;
    display: block;
}

li {
    cursor: pointer;
    padding: 5px;
    margin: 5px 0;
    border: 1px solid $white;
    border-radius: 3px;
    font-weight: bold;
    transition: background-color 0.2s ease-in-out;
}

li:hover {
    font-weight: 600;
    color: $white;
    background-color: $primary;
}

li:active {
    background-color: $grey;
}
</style>